import { CultureInfo } from '../culture-info.model';
import { CultureInfoFfLatn } from './ff-Latn';

/**
 * @ignore
 */
export const CultureInfoFfLatnGW: CultureInfo = {
  name: 'ff-Latn-GW',
  displayName: 'Pulaar (Latn, Gine-Bisaawo)',
  iso3LanguageCode: 'ful',
  iso2LanguageCode: 'ff',
  ietfLanguageTag: 'ff-Latn-GW',
  parent: CultureInfoFfLatn
};
